import { createSlice } from "@reduxjs/toolkit";
import { getBookings } from "./_bookingsAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const bookings = createSlice({
  name: "bookings",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getBookings.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getBookings.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data || [];
        state.responseMessage = payload.responseMessage;
        state.responseCode = payload.responseCode;
        state.totalRecord = payload.totalRecord || 0;
      })
      .addCase(getBookings.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
